import React from "react";
import { UiPinkCard } from "../../_uiComponents/common/UiPinkCard";
import ServiceCardImage from "../../../styles/img/service-card.png";
import Slider from "react-slick";
import DefaultBannerImage from "../../../styles/img/default-home-banner2.png";

export const BannerSlider = (props) => {
  const { bannersList = [] } = props;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      {bannersList.length > 0 ? 
        <Slider {...settings} className="df-db-card-slider">
          {bannersList.map((e, index) => {
              return (
                <UiPinkCard
                  key={e.id ?? index}
                  className="df-db-solution-card"
                  bgImgUrl={e.image}
                />
              );
          })}
        </Slider> : 
        <div>
          <UiPinkCard
            key={"default-banner"}
            className="df-db-solution-card"
            bgImgUrl={DefaultBannerImage}
          />
        </div>
      }
    </>
  );
};
